import WidgetModule from "@eisinc/Overrides/Widgets/AccountSettings/DefaultShippingAddress";

export * from "@eisinc/Overrides/Widgets/AccountSettings/DefaultShippingAddress";

export default WidgetModule;
